/**
 * vendor
 */
import React, { useEffect, useRef, useContext } from 'react';

/**
 * caribcaribe7
 */
import { LocalStorage } from '@shared/services/main/storage';
import EVENT_NAMES      from '@shared/lib/constants/events';
import Emitter          from '@shared/services/main/events';

import { UserSessionContext } from '@features/auth/stores/user-session-store';
import SessionService         from '@features/auth/services/auths/SessionService';

function UserLoad() {
  const context = useContext(UserSessionContext);
  const sessionServiceRef = useRef(null);
  const componentLikeRef = useRef(null);

  /**
   * Sync user to context
   */
  const syncUser = () => {
    const [, dispatch] = context;
    const localUser = LocalStorage.get('user') || {};
    dispatch({type: 'SET_USER', payload: localUser});
  };

  const onLoginSuccess = () => {
    syncUser();
  };

  const onLogoutSuccess = () => {
    syncUser();
  };

  useEffect(() => {
    // Create component-like object for service
    const componentLike = {
      setState: () => {},
      state: {},
      context
    };

    componentLikeRef.current = componentLike;
    sessionServiceRef.current = new SessionService(componentLike);

    sessionServiceRef.current.registerSessionEvents(componentLike, sessionServiceRef.current);
    sessionServiceRef.current.watchSessionId();

    const loginSuccessHandler = onLoginSuccess;
    const logoutSuccessHandler = onLogoutSuccess;

    Emitter.register(
      EVENT_NAMES.AUTH.LOGIN_SUCCESS_AFTER + '-user-load',
      loginSuccessHandler
    );
    Emitter.register(
      EVENT_NAMES.AUTH.LOGOUT_SUCCESS_AFTER + '-user-load',
      logoutSuccessHandler
    );
    
    syncUser();

    return () => {
      if (sessionServiceRef.current) {
        sessionServiceRef.current.stopWatchingSession();
        sessionServiceRef.current.removeSessionEvents();
      }
      Emitter.off(EVENT_NAMES.AUTH.LOGIN_SUCCESS_AFTER + '-user-load');
      Emitter.off(EVENT_NAMES.AUTH.LOGOUT_SUCCESS_AFTER + '-user-load');
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (<></>);
}

export default UserLoad;
